'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./EmptyListPlaceholder.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var placeholderDefault = _react2.default.createElement('div', { className: 'default-placeholder' });

var EmptyListPlaceholder = function EmptyListPlaceholder(props) {
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('EmptyListPlaceholder', { hovered: props.isHovered }) },
        props.placeholderComponent ? props.placeholderComponent : placeholderDefault
    );
};

EmptyListPlaceholder.propTypes = {
    isHovered: _propTypes2.default.bool,
    placeholderComponent: _propTypes2.default.element
};

exports.default = EmptyListPlaceholder;


//////////////////
// WEBPACK FOOTER
// ./src/client/list/EmptyListPlaceholder.js
// module id = 2031
// module chunks = 0